import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { AVATAR_SIZES } from '@atlaskit/avatar';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { getModalMenuPortalStyles } from 'src/styles/select';

const outlineWidth = 2;
const akSortSelectWidth = `168px`;

// overrides default styling for AvatarGroup avatar
const outline = (color: string) =>
  css({
    boxShadow: `0 0 0 ${outlineWidth}px ${color}`,
    backgroundColor: `${token('elevation.surface')} !important`,
    outline: 'none',
  });

export const FilterAndSortSettings = styled.div({
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  width: '100%',
});

// AK Select component for "Sort by" options
export const getSortBySelectStyles = (isSiteBannerOpen: boolean) => ({
  ...getModalMenuPortalStyles(isSiteBannerOpen),
  menu: (base: Record<string, any>) => ({
    ...base,
    zIndex: 200,
  }),
  // Select components outer most layer
  container: (base: Record<string, any>) => ({
    ...base,
    flex: 1,
    maxWidth: akSortSelectWidth,
    width: akSortSelectWidth,
  }),
});

export const AvatarInnerButton = styled.button({
  "&[aria-pressed='true']": outline(colors.B400),
  '&:focus': outline(colors.B200),
  '& > span': {
    height: `${AVATAR_SIZES.medium}px`,
    backgroundColor: token('color.background.input'),
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
});
